import { safeApiRequest } from './apiClient';

const GORUSME_KAYITLARI_ENDPOINT = '/api/gorusme-kayitlari';

/**
 * Görüşme kaydı oluştur (müşteri seçildiğinde veya müşteri oluştur tıklandığında)
 * @param {{ musteriId?: string, kaynak?: string, telefon?: string }} payload
 */
export const createGorusmeKaydi = async (payload = {}) => {
  const response = await safeApiRequest(GORUSME_KAYITLARI_ENDPOINT, {
    method: 'POST',
    body: payload,
    skipCsrf: false,
  });
  return response;
};

/**
 * Santral cevaplandığında görüşme kaydı başlat
 * @param {{ telefon: string, sipCallId?: string }} payload
 */
export const santralBaslatGorusmeKaydi = async (payload) => {
  const response = await safeApiRequest(`${GORUSME_KAYITLARI_ENDPOINT}/santral-baslat`, {
    method: 'POST',
    body: payload,
    skipCsrf: false,
  });
  return response;
};

/**
 * Görüşme kaydı güncelle (durum, servisKaydiId, musteriId, cagriBitis)
 * @param {string} id - Görüşme kaydı ID
 * @param {{ durum?: string, servisKaydiId?: string, musteriId?: string, cagriBitis?: string, telefon?: string, sonlanmaSebebi?: string, notlar?: string }} payload
 */
export const updateGorusmeKaydi = async (id, payload) => {
  const response = await safeApiRequest(`${GORUSME_KAYITLARI_ENDPOINT}/${id}`, {
    method: 'PATCH',
    body: payload,
    skipCsrf: false,
  });
  return response;
};

/**
 * Görüşme kayıtlarını listele (Admin/Mod)
 */
export const fetchGorusmeKayitlari = async (params = {}) => {
  const response = await safeApiRequest(GORUSME_KAYITLARI_ENDPOINT, { method: 'GET', query: params });
  return response;
};

/** Tekil görüşme kaydı getir */
export const fetchGorusmeKaydiById = async (id) => {
  const response = await safeApiRequest(`${GORUSME_KAYITLARI_ENDPOINT}/${id}`, { method: 'GET' });
  return response;
};

/**
 * Çağrı koptuğunda otomatik sonlandır
 */
export const otomatikSonlandirGorusmeKaydi = async (id) => {
  const response = await safeApiRequest(`${GORUSME_KAYITLARI_ENDPOINT}/${id}/otomatik-sonlandir`, {
    method: 'POST',
    body: {},
    skipCsrf: false,
  });
  return response;
};
